/*
 * Created on 01.11.2018
 *
 * Copyright(c) 1995 - 2016 T-Systems Multimedia Solutions GmbH
 * Riesaer Str. 5, 01129 Dresden
 * All rights reserved.
 */
import { AnimationTriggerMetadata, animate, group, keyframes, state, style, transition, trigger } from '@angular/animations';

/**
 * Konfiguration für Animationen.
 * @author thm
 */

// Könnte anstelle einer einzelnen Animationzeit auch genommen werden. (300ms ease-in-out --> 300ms cubic...)
const ANIMATION_TIMINGS = '300ms cubic-bezier(0.42, 0, 0.58, 1)'; // ease-in-out

/**
 * function to create a slide-in animation.
 * @param direction
 * @param translateFnctname
 */
export function slideContent(direction, translateFnctname): AnimationTriggerMetadata {
    return trigger('slideContent_' + direction, [
        state('void', style({ transform: translateFnctname, opacity: 0 })),
        state(':enter', style({ transform: 'none' })),
        transition(':enter', [ // oder auch 'void => *'
            group([
                animate('300ms ease-in-out'),
                animate('700ms', keyframes([
                    style({ opacity: .1 }),
                    style({ opacity: .5 }),
                    style({ opacity: 1 })
                ]))])
        ]),
        transition(':leave', [ // oder auch '* => void'
            animate('300ms ease-in-out')
        ])
    ]);
}

/**
 * Wiederverwendbare Animation für Dropdowns die sich in einem CDK Overlay befinden.
 * Durch das "Abdocken" des Overlays vom DOM und die absolute Positionierung ist ein SlideDown von der Position des Triggers
 * sehr schwierig bis unmöglich. Diese Variante nutzt daher eine etwas andere Animation.
 * Verwendung in der Komponente:
 *     animations: [
 dropdownAnimation()
 ]
 *
 */
export function dropdownAnimation(): AnimationTriggerMetadata {
    return trigger('dropdownAnim', [
        state('void', style({ opacity: 0 })),
        state(':enter', style({ transform: 'none', opacity: 1 })),
        state(':leave', style({ opacity: 0 })),
        transition('* => *', animate('200ms cubic-bezier(0.25, 0.8, 0.25, 1)'))
    ]);
}

/**
 * Wiederverwendbare Animation für Dropdowns die kein CDK-Overlay benutzen. Die Positionierung des Containers
 * ist durch CSS geregelt und wird vom Trigger-Element umfasst.
 * Note: Eigentlich sollte die Angabe von max-Height ausreichend sein. Warum auch immer, aber angular animiert dann
 * nicht korrekt. height ist zusätzlich (bzw. auch alleine) nötig.
 * ######################################################################################################################################
 * ### ACHTUNG: Diese Animation darf aktuell noch nicht benutzt werden bis wir uns global entscheiden, die CSS Animation zu ersetzen. ###
 * ######################################################################################################################################
 *
 */
// Animationsdauer ist auch durch max-height beschrönkt :/ vielleicht sollte man mehrere Animationen anbieten:
    // mit max-height 200px, 500px, 1000px, 2000px...
export const slideInOutAnimation = trigger('slideInOutAnim', [
    transition(':enter', [
        style({ maxHeight: 0, visibility: 'hidden' }),
        group([
            animate('1ms ease-in-out', style({
                visibility: 'visible'
            })),
            animate('300ms ease-in-out', style({
                maxHeight: '1000px',
                opacity: '1',
            }))
        ])
    ]),
    transition(':leave', [
        style({ maxHeight: '*', visibility: '*' }),
        group([
            animate('300ms ease-in-out', style({
                maxHeight: '0',
                opacity: '0',
                visibility: 'hidden'
            }))
        ])
    ])
]);
